import { PromptTemplateCategory } from '../types';

export const dialogue: PromptTemplateCategory = {
  title: "对话",
  icon: "💬",
  templates: [
    {
      title: "播客访谈模板",
      content: `写一段两位说话者之间的播客式访谈。
- 说话者1是主持人：[一位充满好奇心和热情的科技记者]。
- 说话者2是嘉宾：[一位刚发表突破性论文的知名AI研究员]。
- 讨论的话题是[人工智能与人类在创意领域合作的未来]。
- 语气应该是[对话式的、有见地的，偶尔带点幽默]。
- 包含自然的对话互动，包括追问和趣闻轶事。

每行格式为"Speaker 1:"或"Speaker 2:"后接对话内容。`,
      mode: 'multi'
    },
    {
      title: "辩论模板",
      content: `写一段两位说话者之间的结构化辩论，双方持相反观点。
- 说话者1支持[远程办公应该成为永久默认模式]。
- 说话者2认为[办公室协作对创新至关重要]。
- 双方都应该提出[有充分论据和现实案例支持的观点]。
- 语气应该是[尊重但充满激情的]。
- 每位说话者应直接回应对方的论点。

每行格式为"Speaker 1:"或"Speaker 2:"后接对话内容。`,
      mode: 'multi'
    },
    {
      title: "语言学习对话模板",
      content: `写一段两位说话者之间的对话，适合语言学习者。
- 场景是[在一个热闹的街头市场点餐]。
- 说话者1是[一位友好的当地摊主，推荐他们最好的菜品]。
- 说话者2是[一位第一次品尝当地美食的旅行者]。
- 包含[自然的停顿、礼貌用语和文化背景]。
- 对话应该真实自然，帮助学习者掌握[日常会话短语]。

每行格式为"Speaker 1:"或"Speaker 2:"后接对话内容。`,
      mode: 'multi'
    }
  ]
};
